import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 10",
  height: "48",
  width: "48",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2.092,9.477.514,7.9a1.76,1.76,0,0,1,0-2.484l1.206-1.2A.75.75,0,1,1,2.78,5.272l-1.2,1.205a.256.256,0,0,0,0,.362L3.152,8.416a.216.216,0,0,0,.362,0l1.206-1.2A.75.75,0,0,1,5.78,8.272l-1.2,1.205A1.755,1.755,0,0,1,2.092,9.477Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.22,5.772a.75.75,0,0,1,0-1.061L8.425,3.506a.257.257,0,0,0,0-.363L6.848,1.566a.217.217,0,0,0-.362,0L5.28,2.772A.75.75,0,0,1,4.22,1.711L5.425.506a1.8,1.8,0,0,1,2.483,0L9.486,2.083a1.759,1.759,0,0,1,0,2.483L8.28,5.772A.749.749,0,0,1,7.22,5.772Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1),
    _createElementVNode("path", {
      d: "M3.72,6.272a.75.75,0,0,1,0-1.061l1.5-1.5A.75.75,0,0,1,6.28,4.772l-1.5,1.5A.749.749,0,0,1,3.72,6.272Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1)
  ])))
}
export default { render: render }